// ========================
// jQuery first - must be global before any legacy code
// ========================
import "../jquery-setup"
import $ from "jquery"

// ========================
// Styles
// ========================
import "../stylesheets/application.scss"

// ========================
// Libraries
// ========================
import "@hotwired/turbo-rails"
import "@rails/activestorage"
import "../channels"
import "trix"
import "@rails/actiontext"

import * as bootstrap from "bootstrap"

// import "tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.min"
import "@fortawesome/fontawesome-free/js/all"
import "@fortawesome/fontawesome-free/css/all.css"
import "whatwg-fetch"

// Image modal handler (delegated)
import "../legacy/image_modal"

// Core DataTables + Bootstrap 5 styling
import "datatables.net";        // core
import "datatables.net-bs5";    // Bootstrap 5 integration

// ========================
// Legacy JS
// ========================
import "../legacy/cocoon"
import "../legacy/general"
import "../legacy/autocomplete"
import "../legacy/trix-or-treat"
import "../legacy/toggle_json"
import "../legacy/pin_modal"
import "../legacy/card_form"
import "../legacy/patron_assign_card"
import "../legacy/deactivate_modal"
import "../legacy/views/messages/general/send/type_of_attachment"
import "../legacy/views/messages/general/send/radio_button_show"
import "../legacy/views/messages/general/send/send_when"
import "../legacy/selected_send_group"
import "../legacy/nested_selected_send_group"
import "../legacy/batch_file_form"
import "../legacy/import_inventory_show"
import "../legacy/event_timeslots"
import "../legacy/nested_tiers_levels"
import "../legacy/nested_check_in_event_configs"
import "../legacy/nested_game_items"
import "../legacy/show_game"
import "../legacy/user_value_fields"
import "../legacy/nested_referral_rewards"
import "../legacy/nested_feature_posts_collections"
import "../legacy/ui-actions/for-feature-post-form"
import "../legacy/ui-actions/for-single-info-post-form"
import "../legacy/ui-actions/for-info-post-third-sub-page-form"
import "../legacy/ui-actions/for-sub-page-info-posts-form"
import "../legacy/reordering/info-post-table"
import "../legacy/reordering/posts-collections"
import "../legacy/action_radio_buttons"
import "../legacy/views/messages/purpose/welcome/recipient_target"
import "../legacy/views/messages/purpose/welcome/card_entity"
import "../legacy/loading_modal"
import "../legacy/dropdown_menu"

import Rails from "@rails/ujs";
Rails.start();



// ========================
// Turbo / DOM initialization
// ========================
// Disable Turbo globally for forms
Turbo.session.drive = false;

document.addEventListener("turbo:load", () => {
  // Initialize DataTables if available
  if (typeof $.fn.dataTable !== 'undefined') {
    // DataTables already available
  }
})
